import { SupportedSubjects } from 'types/Subject';

export const SHEETS_TIMER_NO_VALUE = 'none' as const;

export type SheetsTimerSelectValue = number | typeof SHEETS_TIMER_NO_VALUE;

export const SHEETS_TIMER_MINUTES = [90, 120, 150, 180, 210, 240, 270, 300] as const;

export type SheetsTimerMinutes = typeof SHEETS_TIMER_MINUTES[number];

/**
 * Default exam durations per subject (Formuła 2023, poziom podstawowy / rozszerzony).
 * PP/M/JA use podstawowy times; MR and science/humanities use rozszerzony times.
 */
export const SHEETS_TIMER_DEFAULTS: Record<SupportedSubjects, SheetsTimerMinutes> = {
  PP: 240,
  M: 180,
  MR: 180,
  JA: 120,
  CH: 180,
  B: 180,
  FI: 180,
  GE: 180,
  HI: 180,
};

export const formatSheetsTimerLabel = (minutes: number): string => `${minutes} min`;

export const formatElapsedTime = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds].map(part => String(part).padStart(2, '0')).join(':');
};

export const minutesToSelectValue = (minutes: number | null): SheetsTimerSelectValue =>
  minutes == null ? SHEETS_TIMER_NO_VALUE : minutes;

export const selectValueToMinutes = (value: SheetsTimerSelectValue): number | null =>
  value === SHEETS_TIMER_NO_VALUE ? null : value;
